interface PulseLineIconProps {
  className?: string
}

export default function PulseLineIcon({ className }: PulseLineIconProps) {
  return (
    <svg
      viewBox="0 0 120 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M0 20 L25 20 L35 20 L42 8 L50 32 L58 4 L66 28 L73 20 L85 20 L120 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="empty-state-pulse"
      />
    </svg>
  )
}
